import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EMPTY } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ProjConstants } from 'src/app/utils/proj.constant';
import { UtilsService } from 'src/app/utils/utils.service';
import { environment } from 'src/environments/environment';
import { isNullOrUndefined } from 'util';
import * as L from 'leaflet';

@Injectable({
  providedIn: 'root'
})
export class ColdwaveDataService {
  combinedTimeStampList: any;
  mandalData: Object;
  urlConst: any = environment.url.HEATWAVE_STAGING_API_URL

  constructor(private http: HttpClient, private utils: UtilsService, private datePipe: DatePipe) { }

  getActualData(postData) {
    let url: any;
    url = this.urlConst + 'heatWatches/getObservedHeatWatchesData';
    return this.http.post<any>(url, postData);
  }

  getDistrictData(postData) {
    let url: any;
    url = this.urlConst + 'heatWatches/getHeatWatchesData';
    return this.http.post<any>(url, postData);
  }

  getHeirarchy(postData) {
    let url = this.urlConst + "locations/heirarchy";
    return this.http.post<any>(url, postData)
  }

  getTableDistrictData(postData) {
    let url = this.urlConst + "heatWatches/getHeatWatchesCount";
    return this.http.post<any>(url, postData);
  }
  getWheatColdStressAlert(postData: any) {
  const url = this.urlConst + 'hw/getWheatColdStressAlert';
  return this.http.post<any>(url, postData);
}

  getPostDataForCW(queryParams) {
    const today = new Date();
    const startTs = today.getTime()
    const endTs = today.getTime() + (6 * 24 * 60 * 60 * 1000);
    let distUUID;
    if (queryParams['locType'] == 'DISTRICT') {
      let allLocations = queryParams['location'].split('&')
      distUUID = allLocations[1].split('##')[1]
    }
    let postData = {
      component: "COLDWAVE",
      "sUUID": queryParams['locType'] != 'DISTRICT' ? '00cb31c7-2928-4e6d-adcc-443d478c90d6' : distUUID,
      "pUUID": queryParams['locType'] != 'DISTRICT' ? '00cb31c7-2928-4e6d-adcc-443d478c90d6' : distUUID,
      "pType": queryParams['locType'] != 'DISTRICT' ? "COUNTRY" : "STATE",
      "cType": queryParams['locType'] != 'DISTRICT' ? "DISTRICT" : "BLOCK",
      // "source": 'IMD_LONG_RANGE',
      source: queryParams['source'] || 'IMD_LONG_RANGE',
      "startTs": startTs,
      "endTs": endTs
    }

    return postData
  }

  formatStateData(data, locType) {
    locType = this.toTitleCase(locType)
    let finalData = {};
    let timeStampList = []
    let table_data = []
    for (let locName in data) {
      let locObject = {}
      locObject[locType] = { val: this.utils.formatNames(data[locName]['name']) };
      locObject['uuid'] = data[locName]['uuid'];
      for (let element in data[locName]['table_data']) {
        if (data[locName]['table_data'][element]['data'] == null || data[locName]['table_data'][element]['data'] == undefined) {
          continue;
        }
        let timeStamp = data[locName]['table_data'][element]['timeStamp'];
        if (!timeStampList.includes(timeStamp)) {
          timeStampList.push(timeStamp);
        }
        let timeC = timeStamp.toString() + "_" + "c";
        locObject[timeC] = { val: data[locName]['table_data'][element]['data']['c'] };
        let timeD = timeStamp.toString() + "_" + "d";
        locObject[timeD] = { val: data[locName]['table_data'][element]['data']['d'] };
      }
      // console.log(data[locName]);
      if (data[locName]['centroid'] != undefined && data[locName]['centroid'] != null) {
        locObject['centroid'] = data[locName]['centroid'];
      }
      table_data.push(locObject);
    }
    let sortedTimeStampList = timeStampList.sort()
    let column1 = [];
    column1.push({
      val: locType,
      colspan: 1,
      rowspan: 2,
      sortedHeaderVal: locType,
    })
    let column2 = [];
    let tableHeaders = [];
    tableHeaders.push({ val: locType });
    for (let index in sortedTimeStampList) {
      let tp = sortedTimeStampList[index];
      column1.push({
        val: this.utils.convertModelDatetoDate(tp).toLocaleDateString(),
        colspan: 2,
        rowspan: 1,
        sortedHeaderVal: tp.toString() + "_d"
      })
      column2.push({
        val: 'Coldwave',
        colspan: 1,
        rowspan: 1,
        backgroundColor: ProjConstants.COLD_WATCHES_LEGEND_CHART.Coldwave,
        sortedHeaderVal: tp.toString() + "_c"
      })
      column2.push({
        val: 'Severe Coldwave',
        colspan: 1,
        rowspan: 1,
        backgroundColor: ProjConstants.COLD_WATCHES_LEGEND_CHART.SevereColdwave,
        sortedHeaderVal: tp.toString() + "_d"
      })
      tableHeaders.push({
        val: tp.toString() + "_c"
      })
      tableHeaders.push({
        val: tp.toString() + "_d"
      })
    }
    let tableColumns = []
    tableColumns.push(column1);
    tableColumns.push(column2);
    // Sort the table_data based on today's "d" column in descending order
    const todayTimestamp = new Date().toISOString().slice(0, 10).replace(/-/g, '') + "_d";
    table_data.sort((a, b) => {
      const valA = (a[todayTimestamp] && a[todayTimestamp].val) || 0;
      const valB = (b[todayTimestamp] && b[todayTimestamp].val) || 0;
      return valB - valA; // Change to `valA - valB` for ascending order
    });
    finalData['data'] = table_data;
    finalData['columns'] = tableColumns;
    finalData['tableHeaders'] = tableHeaders;
    return finalData;
  }

  formatChartData(data, chartDataString) {
    let timeStampList = []
    let blockArray = []
    let formattedChartData = [{}, {}, {}];
    formattedChartData[0][chartDataString] = "Severe Coldwave";
    formattedChartData[1][chartDataString] = "Coldwave";
    formattedChartData[2][chartDataString] = "Normal";
    let chartData = {
      "SevereColdwave": {},
      "Coldwave": {},
      "Normal": {}
    };
    let count = 0
    for (let locName in data) {
      let locObject = {}
      for (let element in data[locName]['table_data']) {
        if (data[locName]['table_data'][element]['data'] == null || data[locName]['table_data'][element]['data'] == undefined) {
          continue;
        }
        let timeStamp = data[locName]['table_data'][element]['timeStamp'];
        if (!timeStampList.includes(timeStamp)) {
          timeStampList.push(timeStamp);
        }
        let date = this.utils.convertModelDatetoDate(timeStamp).toLocaleDateString();
        if (chartData["SevereColdwave"][date] == undefined && formattedChartData[0][date] == undefined) {
          chartData["SevereColdwave"][date] = data[locName]['table_data'][element]['data']['d'];
          formattedChartData[0][date] = data[locName]['table_data'][element]['data']['d'];
        }
        else {
          chartData["SevereColdwave"][date] += data[locName]['table_data'][element]['data']['d'];
          formattedChartData[0][date] += data[locName]['table_data'][element]['data']['d'];
        }
        if (chartData["Coldwave"][date] == undefined && formattedChartData[1][date] == undefined) {
          chartData["Coldwave"][date] = data[locName]['table_data'][element]['data']['c'];
          formattedChartData[1][date] = data[locName]['table_data'][element]['data']['c'];
        }
        else {
          chartData["Coldwave"][date] += data[locName]['table_data'][element]['data']['c'];
          formattedChartData[1][date] += data[locName]['table_data'][element]['data']['c'];
        }
        if (chartData["Normal"][date] == undefined && formattedChartData[2][date] == undefined) {
          chartData["Normal"][date] = data[locName]['table_data'][element]['data']['n'];
          formattedChartData[2][date] = data[locName]['table_data'][element]['data']['n'];
        }
        else {
          chartData["Normal"][date] += data[locName]['table_data'][element]['data']['n'];
          formattedChartData[2][date] += data[locName]['table_data'][element]['data']['n'];
        }
      }
      count = count + 1;
    }
    let sortedTimeStampList = timeStampList.sort()
    for (let tp of sortedTimeStampList) {
      blockArray.push(this.utils.convertModelDatetoDate(tp).toLocaleDateString());
    }
    // console.log("countxd",count);

    return [chartData, formattedChartData, blockArray, count];
  }

  formatMandalData(data, hval, hcat, gis, actualData?) {
    let totalTableData: any;
    // if (actualData.length > 0) {
    //   totalTableData = this.fetchTotData(actualData, data);
    // } else {
    totalTableData = data
    // }
    return new Promise((resolve, reject) => {
      const finalData = {};
      const timeStampList = [];
      let currentDate = this.getCurrentDateInYYYYMMDDFormat1();
      for (const locName of Object.keys(data)) {
        if (data[locName]['table_data'] == null || data[locName]['table_data'] == undefined) {
          continue;
        }
        let table_data = {};
        for (const index of totalTableData[locName]['table_data']) {
          if (!timeStampList.includes(index['timeStamp'])) {
            timeStampList.push(index['timeStamp']);
          }
          if (index['timeStamp'] == currentDate && totalTableData[locName]['table_data'].length > 0) {
            for (let actualLocName of Object.keys(totalTableData)) {
              if (totalTableData[actualLocName]['uuid'] == data[locName]['uuid']) {
                table_data[index['timeStamp']] = {
                  val: totalTableData[actualLocName]['table_data'][0]['data'][hval],
                  cat: totalTableData[actualLocName]['table_data'][0]['data'][hcat]
                };
              }
            }

          } else {
            table_data[index['timeStamp']] = {
              val: index['data'][hval],
              cat: index['data'][hcat]
            };
          }
        }
        const locData = {
          name: data[locName].name,
          pName: data[locName].pName,
          uuid: data[locName].name,
          'table_data': table_data
        };
        finalData[data[locName].uuid] = locData;
      }
      const sortedTimeStampList = this.combinedTimeStampList.sort();
      // const sortedTimeStampList = timeStampList.sort();
      gis.labelStrings = this.createLabels(sortedTimeStampList);
      let index: any = 0;//this.setBlockNumber();
      gis.activeGroup = sortedTimeStampList[index];
      resolve(finalData);
    })
  }

  formatMandalDataForTable(data, hval, hcat, component?) {
    let finalData = {};
    let table_dataForMandal = [];
    let timeStampList = [];
    for (let locName of Object.keys(data)) {
      if (data[locName]['table_data'] == null || data[locName]['table_data'] == undefined) {
        continue;
      }
      let locObject = {};
      for (let index of data[locName]['table_data']) {
        if (!timeStampList.includes(index['timeStamp'])) {
          timeStampList.push(index['timeStamp']);
        }
        if (!(Number(index['data'][hval]).toFixed(2) == "NaN")) {
          locObject[index['timeStamp']] = {
            val: Number(index['data'][hval]).toFixed(2),
            backgroundColor: ProjConstants.COLD_WATCHES_LEGEND[index['data'][hcat]],


          }
        }
      }
      // locObject['District'] = { val: this.utils.formatNames(data[locName]['pName']) }
      locObject['Mandal'] = { val: this.utils.formatNames(data[locName]['name']) }
      if (data[locName]['centroid'] != undefined && data[locName]['centroid'] != null) {
        locObject['centroid'] = data[locName]['centroid'];
      }
      table_dataForMandal.push(locObject)
    }
    let sortedTimeStampList = timeStampList.sort();
    let column1 = [];
    column1.push({
      val: 'Mandal',
      colspan: 1,
      rowspan: 1,
      sortedHeaderVal: 'Mandal',
    })
    // column1.push({
    //   val: 'District',
    //   colspan: 1,
    //   rowspan: 1,
    //   sortedHeaderVal: 'District',
    // })
    let tableHeaders = [];
    tableHeaders.push({ val: 'Mandal' });
    // tableHeaders.push({ val: 'District' });
    for (let index in sortedTimeStampList) {
      let tp = sortedTimeStampList[index];
      column1.push({
        val: this.utils.convertModelDatetoDate(tp).toLocaleDateString(),
        colspan: 1,
        rowspan: 1,
        sortedHeaderVal: tp.toString()
      })
      tableHeaders.push({
        val: tp.toString()
      })
    }
    let tableColumns = []
    tableColumns.push(column1);
    finalData['data'] = table_dataForMandal;
    finalData['columns'] = tableColumns;
    finalData['tableHeaders'] = tableHeaders;
    console.log("mandal data::", finalData);

    return finalData;
  }

  fetchTotData(dataA: any, dataB: any) {
    let objA: any = this.fetchObj(dataA);
    let objB: any = this.fetchObj(dataB);
    let keys: any = Object.keys(objA);
    let finalArr: any = [];
    let obj: any = {}
    for (let i: any = 0; i < keys.length; i++) {
      let obj: any = {};
      obj = { ...obj, ...objA[keys[i]] };
      let newArr: any = [];
      newArr = newArr.concat(objA[keys[i]]['table_data']);
      if (!isNullOrUndefined(objB[keys[i]])) {
        newArr = newArr.concat(objB[keys[i]]['table_data']);
      }
      obj['table_data'] = this.removeDuplicates(newArr);

      finalArr.push(obj);
    }
    return finalArr;
  }

  fetchObj(data: any) {
    let obj: any = {};
    for (let i: any = 0; i < data.length; i++) {
      obj[data[i]['uuid']] = data[i];
    }

    return obj;
  }

  removeDuplicates(data: any) {
    const uniqueTimestamps = new Set<number>();
    const filteredData = data.filter(item => {
      if (!uniqueTimestamps.has(item.timeStamp)) {
        uniqueTimestamps.add(item.timeStamp);
        return true;
      }
      return false;
    });
    return filteredData;
  }

  getCurrentDateInYYYYMMDDFormat1() {
    const currentDate = new Date();
    const threeDaysAgo = new Date(currentDate);
    threeDaysAgo.setDate(currentDate.getDate() - 3); // Set date to three days ago

    const year = threeDaysAgo.getFullYear();
    const month = String(threeDaysAgo.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const day = String(threeDaysAgo.getDate()).padStart(2, '0');

    const formattedDate = `${year}${month}${day}`;
    return formattedDate;
  }

  createLabels(tsList) {
    const labelStrings = [];
    let device = this.utils.getDeviceType()
    let labels
    for (const ts of tsList) {
      if (device == 'mobile') {
        labels = this.utils.convertModelDatetoDateForMobile(ts)
        labels = this.datePipe.transform(labels, "dd/MM")
      }
      else if (device == 'desktop') {
        labels = this.utils.convertModelDatetoDate(ts).toLocaleDateString()
      }
      labelStrings.push({
        groupName: ts,
        label: {
          label: labels,
          toolTip: '5:30 AM - 5:30 AM'
        },
        fullLabel: labels
      });
    }
    return labelStrings;
  }

  setBlockNumber() {
    const currentDate = new Date();
    const currentHour = currentDate.getHours();
    const currentMinutes = currentDate.getMinutes();

    let index;

    if (currentHour > 17 || (currentHour === 17 && currentMinutes >= 30)) {
      // After 5:30 PM
      index = 3;
    } else {
      // Before 5:30 PM
      index = 2;
    }
    return index;
  }

  getChartData(categories, chartData, params?: any) {
    let locType = params['locType'] != 'STATE' ? 'Districts' : 'Blocks'
    let options: object = {
      chart: {
        type: 'column',
        backgroundColor: '#000000' // or any hex, rgb, or rgba value
      },
      title: {
        text: '',
        style: {
          color: '#ffffff'
        }
      },
      xAxis: {
        categories: categories,
        // title: {
        //   text: 'Dates',
        //   style: {
        //     color: '#ffffff'
        //   }
        // },
        labels: {
          style: {
            color: '#9aa2a7ff' ,
            fontFamily: 'poppins, sans-serif',// x-axis label color
          }
        },
        crosshair: true
      },
      yAxis: {
        min: 0,
        title: {
          text: 'No of ' + locType,
          style: {
            color: '#9aa2a7ff',
            fontFamily: 'poppins, sans-serif',
          }
        },
        labels: {
          style: {
            color: '#9aa2a7ff',
            fontFamily: 'poppins, sans-serif', // x-axis label color
          }
        },
        gridLineColor: '#808080'
        // stackLabels: {
        //   enabled: true,
        //   style: {
        //     fontWeight: 'bold'
        //   }
        // }
      },
      legend: {
         layout: 'horizontal',
  align: 'center',
  verticalAlign: 'bottom',
  itemMarginTop: 4,
  itemMarginBottom: 4,
  symbolRadius: 0,
        itemStyle: { color: '#9aa2a7ff',
            fontFamily: 'poppins, sans-serif',
            fontSize: '10px',
    fontWeight: 'normal'
           }
      },
      tooltip: {
        headerFormat: '<b>{point.x}</b><br/>',
        pointFormat: '{series.name}: {point.y}<br/>Total: {point.stackTotal}'
      },
      plotOptions: {
        column: {
          stacking: 'normal',
          dataLabels: {
            enabled: true
          }
        }
      },
      series: [
        {
          name: 'Severe Coldwave',
          type: 'column',
          data: categories.map(date => chartData.SevereColdwave[date] || 0),
          color: '#2F6D9D'
        },
        {
          name: 'Coldwave',
          type: 'column',
          data: categories.map(date => chartData.Coldwave[date] || 0),
          color: '#74ABD6'
        },
        {
          name: 'Normal',
          type: 'column',
          data: categories.map(date => chartData.Normal[date] || 0),
          color: '#FFFACD'
        }
      ],
      credits: {
        enabled: false
      }
    }
    return options;
  }

  toTitleCase(str: string) {
    const strng = [];
    str.split(' ').forEach((st: string) => {
      strng.push(st[0].toUpperCase() + st.substr(1).toLowerCase());
    });
    return strng.join(' ');
  }

  public getFeatureInfo(latlng: any, layer: any, map: any) {
    let url = this.getFeatureInfoUrl(latlng, layer, map);
    return this.http.get(url).pipe(
      catchError((err) => {
        return EMPTY;
      })
    );
  }
  public getFeatureInfoUrl(latlng: any, layer: any, map: any) {
    // if(!isNullOrUndefined(latlng.latlng)){
    //   latlng = latlng.latlng
    // }
    let point = map.latLngToContainerPoint(latlng, map.getZoom());
    let size = map.getSize();
    let params: any = {
      request: 'getFeatureInfo',
      service: 'WMS',
      srs: 'EPSG:4326',
      transparent: true,
      version: layer ? layer.wmsParams.version : '',
      format: layer ? layer.wmsParams.format : '',
      bbox: map.getBounds().toBBoxString(),
      height: Math.floor(size.y),
      width: Math.floor(size.x),
      layers: layer ? layer.wmsParams.layers : '',//queryLayers.join(','),
      query_layers: layer ? layer.wmsParams.layers : '',//queryLayers.join(','),
      info_format: 'application/json',
      feature_count: 50,
      VIEWPARAMS: layer ? (layer.wmsParams.VIEWPARAMS ? layer.wmsParams.VIEWPARAMS : '1=1') : ''
      // CQL_FILTER: layer ? (layer.wmsParams.cql_filter ? layer.wmsParams.cql_filter : '1=1') : ''
    };
    params[params.version === '1.3.0' ? 'i' : 'x'] = Math.floor(point.x);
    params[params.version === '1.3.0' ? 'j' : 'y'] = Math.floor(point.y);
    let url = layer._url + (L as any).Util.getParamString(params, layer._url, true);
    return url;
  }

  get10DaysTimeStamps(source, timestamp) {
    let hoursIncrement = 0;
    let startHour;
    if (timestamp.endsWith('00')) {
      startHour = 8
    } else {
      startHour = 20
    }
    // if (source == 'IMD') {
    //   hoursIncrement = ProjConstants.SOURCE_TIMESTAMP_DIFF.IMD;
    //   startHour = 8;
    // }
    const today = new Date();
    const refTs = today.getTime();
    // let refTs = ProjConstants.RefTs24;
    const start = new Date(refTs);
    start.setHours(startHour, 30, 0, 0);
    const dayStartTs = start.getTime();
    const blocks = {};
    for (let i = 0; i < 7; i++) {
      blocks[i] = {};
      // blocks[i]['timeStamp'] = dayStartTs + ((i) * 86400000);
      blocks[i]['timeStamp'] = dayStartTs + ((i) * 86400000) - hoursIncrement;
      blocks[i]['timeLineName'] = {};
      blocks[i]['timeLineName']['label'] = this.convetTimeStampToDay(blocks[i]['timeStamp'] + hoursIncrement);
      blocks[i]['timeLineName']['toolTip'] = source == 'IMD' ? '8:30 AM - 8:30 AM' : '5:30 AM - 5:30 AM';
      blocks[i]['leftSideName'] = this.convetTimeStampToDay(blocks[i]['timeStamp'] + hoursIncrement);
      blocks[i]['timeLinePos'] = i;
      blocks[i]['groupName'] = this.millisToYYYYMMDD(blocks[i]['timeStamp'])
    }
    return blocks;
  }

  millisToYYYYMMDD(currentMillis: number): number {
    const d = new Date(currentMillis);

    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');

    return Number(`${year}${month}${day}`);
  }

  convetTimeStampToDay(ts) {
    const date = new Date(ts).toLocaleDateString();
    return date;
  }

  getForecastFileTimeStamp(primarySource, secondarySource) {
    let url = ProjConstants.API_URL + ProjConstants.API_MAPPING['FORECASTFILES'] + '/' + primarySource + "/" + secondarySource;
    let promise = new Promise((resolve, reject) => {
      this.http.get(url).subscribe(data => {
        let max = data[primarySource];
        for (let source in data) {
          if (max == undefined || Number(data[source]) > max) {
            max = Number(data[source])
          }
        }
        resolve(max.toString())
      })
    })
    return promise
  }

  getWindData(url) {
    let dataPromise = new Promise((resolve, reject) => {
      this.http.get(url).subscribe(
        data => {
          let obj = this.setWindData(data);
          resolve(obj);
        }
      )
    })
    return dataPromise;
  }

  setWindData(data) {
    for (let block of Object.keys(data)) {
      let array = [];
      let obj1 = new Object();
      obj1['header'] = {
        "parameterUnit": "m.s-1",
        "parameterNumber": 2,
        "dx": 0.5,
        'dy': 0.5,
        "parameterNumberName": "eastward_wind",
        "la1": 40.0,
        "la2": 5.0,
        'parameterCategory': 2,
        "lo2": 100.0,
        "nx": 71,
        "ny": 71,
        "refTime": "2017-02-01 23:00:00",
        "lo1": 65.0
      };
      obj1['data'] = data[block]['data1'];
      array[0] = obj1;

      let obj2 = {};
      obj2["header"] = {
        "parameterUnit": "m.s-1",
        "parameterNumber": 3,
        "dx": 0.5,
        "dy": 0.5,
        "parameterNumberName": "eastward_wind",
        "la1": 40.0,
        "la2": 5.0,
        "parameterCategory": 2,
        "lo2": 100.0,
        "nx": 71,
        "ny": 71,
        "refTime": "2017-02-01 23:00:00",
        "lo1": 65.0
      };
      obj2['data'] = data[block]['data2'];
      array[1] = obj2;
      return array;
    }
  }
// getDistrictDonutOptions(): Highcharts.Options {
//   const data = {
//     severe: 15,
//     cold: 38,
//     normal: 92
//   };

//   const total = data.severe + data.cold + data.normal;

//   return {
//     chart: {
//       type: 'pie',
//       backgroundColor: 'transparent'
//     },
//     title: { text: '' },
//     plotOptions: {
//       pie: {
//         innerSize: '70%',
//         dataLabels: {
//           enabled: true,
//           format: '{point.name}<br>{point.y}',
//           style: { color: '#ffffff' }
//         }
//       }
//     },
//         legend: {
//       enabled: true, // ✅ make legend visible
//       itemStyle: {
//         color: '#ffffff', // legend text color
//         fontWeight: 'normal'
//       }
//     },

//     series: [{
//       type: 'pie',
//       data: [
//         { name: 'Severe Coldwave', y: data.severe },
//         { name: 'Coldwave', y: data.cold },
//         { name: 'Normal', y: data.normal }
//       ]
//     }],
//     credits: { enabled: false }
//   };
// }
getDistrictDonutOptions(): Highcharts.Options {
  const data = [
    { name: 'Normal', y: 51.0, color: '#3399FF', showInLegend: true },
    { name: 'Cold Stress', y: 49.0, color: '#DB1A1A', showInLegend: true }
  ];

  return {
    chart: {
      type: 'pie',
      backgroundColor: 'transparent'
    },
    title: { text: '' },
    plotOptions: {
      pie: {
        innerSize: '70%',
        dataLabels: {
          enabled: true,
          format: '{point.name}<br>{point.y}%',
          style: { color: '#ffffff' }
        },
        showInLegend: true
      }
    },
    legend: {
      enabled: true,
      align: 'center',
      verticalAlign: 'bottom',
      itemStyle: {
        color: '#ffffff'
      }
    },
    series: [{
      type: 'pie',
      data: data
    }],
    credits: { enabled: false }
  };
}

}
